export default {
  'onlineStore.store': 'ร้านค้า',
  'onlineStore.coming_soon': 'เตรียมพบกับสินค้าใหม่เร็วๆ นี้',
  'onlineStore.sold_out': 'ขายหมดแล้ว',
  'onlineStore.piece': 'ชิ้น',
  'onlineStore.original_price': 'ราคาปกติ',
  'onlineStore.empty': 'ขณะนี้ยังไม่มีสินค้า',
  'onlineStore.text.building': 'กำลังจัดเตรียมเนื้อหา',
  'onlineStore.text.more_information': 'ดูข้อมูลเพิ่มเติมได้ที่เว็บไซต์หรือโซเชียลมีเดียของแบรนด์',
  'onlineStore.category': 'หมวดหมู่สินค้า',
  'onlineStore.brand': 'แบรนด์',
  'onlineStore.recommend': 'แนะนำ',
  'onlineStore.package': 'แพ็คเกจ',
  'onlineStore.my_product': 'คูปองสินค้าของฉัน',
  'onlineStore.12cm.company_name': 'บริษัท รุ่ยติง ดิจิตอล จำกัด',
  'onlineStore.search_placeholder': 'ค้นหาชื่อสินค้า',
  'onlineStore.search': 'ค้นหา',
  'onlineStore.cancel': 'ยกเลิก',
} as Record<string, string>;
